import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CurrenciesTypeaheadComponent } from '@app/modules/service-data/components/service-data/service-data-finance-details/currencies-typeahead/currencies-typeahead.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-currency-dialog',
  imports: [ReactiveFormsModule, CurrenciesTypeaheadComponent, TranslatePipe],
  templateUrl: './edit-currency-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './edit-currency-dialog.component.scss',
  host: {
    ngbAutofocus: '',
    tabindex: '-1',
  },
})
export class EditCurrencyDialogComponent {
  public currency = signal<string>(null);
  public title = signal<string>('pricing.partner.editCurrency.title');
  public placeholder = signal<string>(
    'pricing.partner.editCurrency.placeholder'
  );
  public onSave = signal<(currency: string) => void>(null);

  protected modalRef = inject(NgbActiveModal);

  protected currencyFormControl = new FormControl<string>(null);

  constructor() {
    effect(() => {
      this.currencyFormControl.setValue(this.currency());
    });
  }

  protected updateCurrency() {
    this.onSave()?.(this.currencyFormControl.value);

    this.modalRef.close();
  }
}
